import * as Sentry from '@sentry/react';

// Only initialize Sentry in production environments (not local development)
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://9d87dd464dc16356f4ca71ecded02e84@o4509237539504128.ingest.us.sentry.io/4509237540552704',
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    integrations: []
  });
}
